<template>
	<div class="parts-locations-general-card">
		<!-- Gross Profit & Tax: Masking, Markups, Price Codes Section -->
		<SectionContainer>
			<template #left>
				<h4>Gross Profit & Tax: Masking, Markups, Price Codes</h4>
			</template>
			<template #content>
				<!-- Gross Profit & Tax Subsection -->
				<dl>
					<dt>Gross Profit & Tax</dt>
					<dd>
						<ExpandableText
							title="Core Charge Tax"
							:value="'Lorem Ipsum Description'"
						/>
					</dd>
				</dl>
				<!-- Masking Subsection -->
				<dl>
					<dt>Masking</dt>
					<dd>
						Mask Hundredths
					</dd>
					<dd>
						Maximum Price
					</dd>
					<dd>
						Minimum Price
					</dd>
					<dd>
						<ExpandableText
							title="Apply to Invoice"
							:value="
								'When checked, the masking defaults will be applied to Parts Invoices'
							"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Apply to Wholesale"
							:value="
								'When checked,  the masking defaults will be applied to wholesale Parts Invoices'
							"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="RO - Client Pay"
							:value="
								'When checked, the masking defaults will be applied to customer pay portions of ROs '
							"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="RO - Internal Pay"
							:value="
								'When checked, the masking defaults will be applied to internal pay portions of ROs'
							"
						/>
					</dd>
				</dl>
				<!-- Markups Subsection -->
				<dl>
					<dt>Markups</dt>
					<dd>Wholesale Markup</dd>
					<dd>Retail Markup</dd>
				</dl>
				<!-- Price Codes Subsection -->
				<dl>
					<dt>Price Codes</dt>
					<dd>
						<ExpandableText
							title="Default NPN Price Code"
							:value="
								'Parts Invoices, Parts Desk, Back Counter, and ROs'
							"
						/>
					</dd>
					<dd>Default NPN Price Codes on Inventory - Price Code 1</dd>
					<dd>Default NPN Price Codes on Inventory - Price Code 2</dd>
					<dd>Default NPN Price Codes on Inventory - Price Code 3</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- Shared Settings Section -->
		<SectionContainer>
			<template #left>
				<h4>Shared Settings</h4>
			</template>
			<template #content>
				<!-- Shared Settings -->
				<dl>
					<dd>
						<ExpandableText
							title="Part Cost Default Visibility"
							:value="
								'Parts Inventory, Parts Invoices, Parts Desk, Back Counter, and ROs'
							"
						/>
					</dd>
					<dd>Default Account Code</dd>
					<dd>
						<ExpandableText
							title="Minimum GP% Repair Orders"
							:value="
								'The minimum gross profit percentage needed for ROs'
							"
						/>
					</dd>
					<dd>Verify Warranty Parts Received</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- Integrations Section -->
		<SectionContainer>
			<template #left>
				<h4>Integrations</h4>
			</template>
			<template #content>
				<dl>
					<dd>
						<ExpandableText
							title="MyPrice Link"
							:value="
								'OEC Integration that provides real-time OEM List and Wholesale/Trade prices for collision parts'
							"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="EPC Providers - Provider"
							:value="'lorem ipsum description'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="EPC Providers - Manufacturer"
							:value="'lorem ipsum description'"
						/>
					</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- Inventory Section -->
		<SectionContainer>
			<template #left>
				<h4>Inventory</h4>
			</template>
			<template #content>
				<dl>
					<dd>
						<ExpandableText
							title="Physical Inventory Index"
							:value="
								'Part number sorting for physical inventory'
							"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Part OHQ Alert"
							:value="
								'This default will turn the Special Order prompt on or off on certain screens'
							"
						/>
					</dd>
					<dd>Default Bin</dd>
					<dd>Search Part Base</dd>
					<dd>Order Source Prompt</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- Parts Desk Section -->
		<SectionContainer>
			<template #left>
				<h4>Parts Desk</h4>
			</template>
			<template #content>
				<dl>
					<dd>Desk Expiration Days</dd>
					<dd>Next Part Desk</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- Parts Invoice Section -->
		<SectionContainer>
			<template #left>
				<h4>Parts Invoice</h4>
			</template>
			<template #content>
				<dl>
					<dd>
						<ExpandableText
							title="Auto Pay Cash"
							:value="'Lorem Ipsum Description'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Auto Pay Charge"
							:value="'Lorem Ipsum Description'"
						/>
					</dd>
					<dd>Parts Invoice Client#</dd>
					<dd>Next Part Invoice</dd>
					<dd>
						<ExpandableText
							title="Minimum GP% Invoice"
							:value="
								'The minimum gross profit percentage needed for parts invoices.'
							"
						/>
					</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- Special Orders Section -->
		<SectionContainer>
			<template #left>
				<h4>Parts Invoice</h4>
			</template>
			<template #content>
				<dl>
					<dd>Parts Order Comment Type</dd>
				</dl>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';
import ExpandableText from '@/components/visual/expandable-text';

export default {
	name: 'PartsLocationsGeneralCard',
	components: { SectionContainer, ExpandableText }
};
</script>

<style lang="scss" scoped>
.parts-locations-general-card {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;

	&__item {
		display: block;
	}

	.section-header {
		display: inline-block;
	}
}
</style>
